import React from "react";
import { MenuItem, ListItemIcon, ListItemText, Typography, Button } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { Dropdown } from "../dropdown/Dropdown.js";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { Icon } from "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
const useStyles = makeStyles()((theme) => ({
  localeContainer: {
    padding: theme.spacing(1, 2.5),
    cursor: "default",
    gap: theme.spacing(2),
    "&:hover": {
      backgroundColor: "transparent"
    },
    "& .MuiListItemIcon-root": {
      minWidth: "unset"
    }
  },
  localeContainerMinimize: {
    margin: "0 auto",
    width: "max-content"
  },
  localeIcon: {
    fontSize: "18px"
  },
  localeButton: {
    minWidth: "unset",
    color: theme.palette.text.primary
  }
}));
function Locale({ label, locales, value, onChange, minimizeMode }) {
  const { classes, cx } = useStyles();
  function handleLocaleClick(locale) {
    onChange(locale);
  }
  const selectedLabel = locales?.find((l) => l?.value === value)?.label;
  return /* @__PURE__ */ React.createElement(MenuItem, { disableRipple: true, disableTouchRipple: true, className: cx(classes.localeContainer, minimizeMode && classes.localeContainerMinimize) }, /* @__PURE__ */ React.createElement(ListItemIcon, null, /* @__PURE__ */ React.createElement(Icon, { icon: CustomIcon.Earth, className: classes.localeIcon })), !minimizeMode && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ListItemText, { disableTypography: true }, /* @__PURE__ */ React.createElement(Typography, { variant: "body2" }, /* @__PURE__ */ React.createElement(LocalizedText, { label }))), /* @__PURE__ */ React.createElement(
    Dropdown,
    {
      triggerButton: ({ onClick }) => /* @__PURE__ */ React.createElement(Button, { onClick, className: classes.localeButton }, /* @__PURE__ */ React.createElement(LocalizedText, { label: selectedLabel })),
      content: locales?.map((l) => /* @__PURE__ */ React.createElement(MenuItem, { key: l?.value, onClick: () => handleLocaleClick(l?.value) }, /* @__PURE__ */ React.createElement(LocalizedText, { label: l?.label })))
    }
  )));
}
export {
  Locale
};
//# sourceMappingURL=Locale.js.map
